import * as Yup from "yup";

const numericPattern = /^\d+$/;

export const physicalChipDeliveryFormSchema = Yup.object({
  iccid: Yup.string()
    .trim()
    .matches(numericPattern, {
      message: "O ICCID deve conter somente números.",
      excludeEmptyString: true
    })
    .required("Informe o ICCID."),

  deliveryByMail: Yup.boolean().required(),

  trackingCode: Yup.string()
    .trim()
    .when("deliveryByMail", {
      is: true,
      then: schema => schema.required("Informe o código de rastreamento."),
      otherwise: schema => schema.optional()
    }),

  rescueProtocol: Yup.string().trim().optional()
});
